import index from './modal'

export default index